import { SVGAttributes } from "react";

function CameraFrontIcon(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="m18 10.5 4-4v11l-4-4V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4.5zm-2-.8V6H4v12h12V9.7zM10 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 1c1.3 0 4 .7 4 2v1H6v-1c0-1.3 2.7-2 4-2z" />
    </svg>
  );
}

export default CameraFrontIcon;
